import moment from "moment";

import { ProviderManagement } from "@/api/interfaces";
import { isEmptyArray } from "@/utils";


export function checkCompleteContactInformation(provider: ProviderManagement.ProviderSchema) {
  if (
    isEmptyArray([
      provider.authorized_official_first_name,
      provider.authorized_official_last_name,
      provider.authorized_official_title,
      provider.authorized_official_phone,
      provider.primary_contact_first_name,
      provider.primary_contact_last_name,
      provider.primary_contact_title,
      provider.primary_contact_phone,
      provider.primary_contact_email,
    ])
  ) {
    return false;
  }

  return true;
}


export function checkCompleteDetails(provider: ProviderManagement.ProviderSchema) {
  if (
    provider.type === ProviderManagement.PROVIDER_TYPE_VALUES.PHARMACY &&
    !provider.pharmacy_nabp_id
  ) {
    return false;
  }

  const requiredFields = [
    provider.start_date, // effective_date doesn't come from provider but there's a start date
    provider.end_date, // end_date doesn't come from provider but there's an end date
    provider.legal_business_name,
    provider.doing_business_as_name,
    provider.physical_address_line_1,
    provider.physical_address_city,
    provider.physical_address_state,
    provider.physical_address_zip_code,
    provider.mailing_address_line_1,
    provider.mailing_address_city,
    provider.mailing_address_state,
    provider.mailing_address_zip_code,
  ];

  return !isEmptyArray(requiredFields);
}
export function checkCompletePaymentRemittance(paymentPreference: ProviderManagement.PaymentPreferenceSchema) {

  if (paymentPreference?.id) {
    /* we have previously saved one
       though the api will not return all the fields, we can assume it's good */
    return true;
  }

  if (
    !paymentPreference?.provider_network_id
    || paymentPreference?.ach_account_type === ProviderManagement.PAYMENT_TYPE_VALUES.ACH
    && isEmptyArray([
      paymentPreference?.financial_institution_name,
      paymentPreference?.financial_institution_address_line_1,
      paymentPreference?.financial_institution_address_city,
      paymentPreference?.financial_institution_address_state,
      paymentPreference?.financial_institution_address_zip_code,
      paymentPreference?.financial_institution_contact_first_name,
      paymentPreference?.financial_institution_contact_last_name,
      paymentPreference?.financial_institution_phone,
      paymentPreference?.financial_institution_fax,
      paymentPreference?.ach_routing_number,
      paymentPreference?.ach_bank_account_number,
      paymentPreference?.account_owner_first_name,
      paymentPreference?.account_owner_last_name,
      paymentPreference?.remittance_address_line_1,
      paymentPreference?.remittance_address_city,
      paymentPreference?.remittance_address_state,
      paymentPreference?.remittance_address_zip_code,
    ])
  ) {
    return false;
  }

  return true;
}

export function checkCompleteDocuments(documents: ProviderManagement.DocumentSchema[]) {
  const docsByType = getDocumentsByType(documents);
  if (!docsByType.authLetter || !docsByType.letterhead || !docsByType.w9) {
    return false;
  }

  return true;
}

const latestDocumentByType = (
  documents: ProviderManagement.DocumentSchema[],
  types: ProviderManagement.DocumentTypeValue[],
): ProviderManagement.DocumentSchema | null => {

  const filteredDocs = documents.filter(
    (d: ProviderManagement.DocumentSchema) => {
      return types.includes(d.document_type);
    },
  ).sort(
    (a: ProviderManagement.DocumentSchema, b: ProviderManagement.DocumentSchema) => {
      return moment.utc(b.created_at).unix() - moment.utc(a.created_at).unix();
    },
  );

  return filteredDocs.length ? filteredDocs[0] : null;
};

type DocumentsByType = {
  authLetter: ProviderManagement.DocumentSchema | null,
  letterhead: ProviderManagement.DocumentSchema | null,
  w9: ProviderManagement.DocumentSchema | null,
}

export const getDocumentsByType = (documents: ProviderManagement.DocumentSchema[]): DocumentsByType => {
  return {
    authLetter: latestDocumentByType(documents, [ProviderManagement.DOCUMENT_TYPE_VALUES.AUTHORIZATION_LETTER_FOR_EFT]),
    letterhead: latestDocumentByType(documents, [
      ProviderManagement.DOCUMENT_TYPE_VALUES.BANK_LETTERHEAD,
      ProviderManagement.DOCUMENT_TYPE_VALUES.VOIDED_CHECK,
    ]),
    w9: latestDocumentByType(documents, [ProviderManagement.DOCUMENT_TYPE_VALUES.W9]),
  };
};
